import React, { useState, useEffect } from 'react'
import { get } from 'lodash'
import { useSelector, useDispatch } from "react-redux"
import { Stack, TablePagination } from '@mui/material'
import { updateListPagination, invalidateList, getPagination } from '../orm/orm_list_actions'

const DEFAULT_ROWS_PER_PAGE = 20

export default function Pagination({ item_list }) {
  const dispatch = useDispatch()
  const listPagination = useSelector(() => item_list.getPagination())

  const handleChangePage = (event, newPage) => {
    dispatch(updateListPagination(item_list.listKey, {page: newPage+1}))
    dispatch(item_list.invalidateList())
    dispatch(item_list.fetchListIfNeeded())
  }

  const handleChangeRowsPerPage = (event) => {
    dispatch(updateListPagination(item_list.listKey, {items_per_page:parseInt(event.target.value, 10), page: 1}))
    dispatch(item_list.invalidateList())
    dispatch(item_list.fetchListIfNeeded())
  }

  return (
    <Stack
      direction="row"
      justifyContent="flex-end"
      alignItems="flex-end"
      spacing={2}
    >
      <TablePagination
        component="div"
        count={get(listPagination, 'num_items', 0)}
        page={get(listPagination, 'current_page', 1) - 1}
        onPageChange={handleChangePage}
        rowsPerPage={get(listPagination, 'items_per_page', DEFAULT_ROWS_PER_PAGE)}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[20, 50, 100]}
        sx={{
          fontSize: 12,
          '& .MuiTablePagination-selectLabel': {
            fontSize: 12,
          },
          '& .MuiTablePagination-displayedRows': {
            fontSize: 12,
          },
          '& .MuiTablePagination-select': {
            fontSize: 12,
          },
        }}
      />
    </Stack>
  )
}
